/* eslint-disable */
export interface paths {
    "/api/v1/auth/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Login */
        post: operations["auth-login"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/refresh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Refresh Token
         * @description Refresh access token using refresh token
         */
        post: operations["auth-refresh_token"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/logout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Logout
         * @description Logout user and invalidate refresh token
         */
        post: operations["auth-logout"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/google/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Google Login
         * @description Return Google OAuth 2.0 PKCE auth URL for SPA redirect.
         */
        get: operations["auth-google_login"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/google/callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Google Callback
         * @description Exchange code for tokens, validate ID token locally, and issue app tokens.
         */
        get: operations["auth-google_callback"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Current User
         * @description Get current user data
         */
        get: operations["users-get_current_user"];
        put?: never;
        post?: never;
        /** Delete Current User */
        delete: operations["users-delete_current_user"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/interests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Interests */
        get: operations["users-get_interests"];
        /** Update Interests */
        put: operations["users-update_interests"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/specialties": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Specialties */
        get: operations["users-get_specialties"];
        /** Update Specialties */
        put: operations["users-update_specialties"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/data-request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Data Request */
        get: operations["users-data_request"];
        put?: never;
        /** Create User Data Request */
        post: operations["users-create_user_data_request"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/change-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Change Password */
        post: operations["users-change_password"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/register": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Register
         * @description Register new user (public endpoint)
         */
        post: operations["users-register"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/confirm-email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm Email
         * @description Confirm user email address
         */
        post: operations["users-confirm_email"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/resend-confirmation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resend Confirmation Email
         * @description Resend email confirmation for inactive users
         */
        post: operations["users-resend_confirmation_email"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/password-recovery/{email}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Recover Password
         * @description Password Recovery
         */
        post: operations["users-recover_password"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/reset-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reset Password
         * @description Reset password
         */
        post: operations["users-reset_password"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/users/password-strength-check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Check Password */
        post: operations["users-check_password"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/specialties": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Specialties
         * @description Get available specialies for the selected country.
         */
        get: operations["specialties-get_specialties"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/specialties/{npi_number}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Specialty From Api
         * @description Retrieve the main doctor specialty based on the provided npi number.
         */
        get: operations["specialties-get_specialty_from_api"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/interests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Interests
         * @description Get interest list.
         */
        get: operations["interests-get_interests"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Profile
         * @description Get user profile for the current user.
         */
        get: operations["profile-get_profile"];
        /**
         * Update Profile
         * @description Update user profile for the current user.
         */
        put: operations["profile-update_profile"];
        /**
         * Create Profile
         * @description Create user profile for the current user.
         */
        post: operations["profile-create_profile"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/view/{article_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * View Article
         * @description Get article detail by it's id. Also marks article as seen.
         */
        get: operations["articles-view_article"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/feed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Feed Articles
         * @description Article feed with interest filtering.
         */
        get: operations["articles-feed_articles"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/saved": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Saved Articles
         * @description Retrieve saved articles for the current user with pagination.
         */
        get: operations["articles-get_saved_articles"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/saved/{article_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Article
         * @description Save an article for the current user.
         */
        post: operations["articles-save_article"];
        /**
         * Remove Saved Article
         * @description Remove a saved article for the current user.
         */
        delete: operations["articles-remove_saved_article"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/excluded/{article_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Exclude Article
         * @description Exclude an article for the current user.
         */
        post: operations["articles-exclude_article"];
        /**
         * Remove Excluded Article
         * @description Remove an excluded article for the current user.
         */
        delete: operations["articles-remove_excluded_article"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/seen": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Seen Articles
         * @description Retrieve seen articles for the current user with pagination.
         */
        get: operations["articles-get_seen_articles"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/seen/{article_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Seen Article
         * @description Mark an article as seen for the current user.
         */
        post: operations["articles-seen_article"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Articles
         * @description Search articles by title, author, or DOI with pagination.
         */
        get: operations["articles-search_articles"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/articles/similar/{article_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Similar Articles
         * @description Retrieve similar articles to the current one.
         */
        get: operations["articles-similar_articles"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/publications/articles/{publication_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Publication Articles
         * @description Retrieve articles for a specific publication.
         */
        get: operations["publications-publication_articles"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/publications/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Publications
         * @description Search publications by name with pagination.
         */
        get: operations["publications-search_publications"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** ArticleDetail */
        ArticleDetail: {
            /** Id */
            id: string;
            /** Title */
            title?: string | null;
            /** Url */
            url?: string | null;
            /**
             * Authors
             * @default []
             */
            authors: string[];
            /** Publication Id */
            publication_id?: string | null;
            /** Publication Name */
            publication_name?: string | null;
            /** Publication Date */
            publication_date?: string | null;
            /**
             * Mesh Tags
             * @default []
             */
            mesh_tags: string[];
            /**
             * Saved
             * @default false
             */
            saved: boolean;
            /**
             * Seen
             * @default false
             */
            seen: boolean;
            /** Abstract */
            abstract?: string | null;
            /**
             * Excluded
             * @default false
             */
            excluded: boolean;
        };
        /** ArticleListResponse */
        ArticleListResponse: {
            /** Articles */
            articles: components["schemas"]["ArticleSummary"][];
            /** Total */
            total: number;
            /** Page */
            page: number;
            /** Page Size */
            page_size: number;
            /** Total Pages */
            total_pages: number;
        };
        /** ArticleSummary */
        ArticleSummary: {
            /** Id */
            id: string;
            /** Title */
            title?: string | null;
            /** Url */
            url?: string | null;
            /**
             * Authors
             * @default []
             */
            authors: string[];
            /** Publication Id */
            publication_id?: string | null;
            /** Publication Name */
            publication_name?: string | null;
            /** Publication Date */
            publication_date?: string | null;
            /**
             * Mesh Tags
             * @default []
             */
            mesh_tags: string[];
            /**
             * Saved
             * @default false
             */
            saved: boolean;
            /**
             * Seen
             * @default false
             */
            seen: boolean;
        };
        /** Body_auth-login */
        "Body_auth-login": {
            /** Email */
            email: string;
            /** Password */
            password: string;
        };
        /** ChangePasswordRequest */
        ChangePasswordRequest: {
            /** Old Password */
            old_password: string;
            /** New Password */
            new_password: string;
        };
        /** DataRequestDetail */
        DataRequestDetail: {
            /**
             * Identifier
             * Format: uuid
             */
            identifier: string;
            status?: components["schemas"]["DataRequestStatus"] | null;
        };
        /**
         * @description **Data Request Statuses**
         *
         *     - 0: NEW
         *     - 5: DONE
         *     - 9: ERROR
         * @example 9
         * @enum {integer}
         */
        DataRequestStatus: DataRequestStatus;
        /** EmailConfirmation */
        EmailConfirmation: {
            /** Token */
            token: string;
        };
        /** ErrorResponse */
        ErrorResponse: {
            /** Detail */
            detail: string;
        };
        /** GoogleCallbackResponse */
        GoogleCallbackResponse: {
            /** Access Token */
            access_token: string;
            /** Refresh Token */
            refresh_token: string;
            /**
             * Token Type
             * @default bearer
             */
            token_type: string;
            user_info?: components["schemas"]["GoogleUserInfo"] | null;
        };
        /** GoogleLoginResponse */
        GoogleLoginResponse: {
            /** Auth Url */
            auth_url: string;
        };
        /** GoogleUserInfo */
        GoogleUserInfo: {
            /** Name */
            name?: string | null;
        };
        /** HTTPValidationError */
        HTTPValidationError: {
            /** Detail */
            detail?: components["schemas"]["ValidationError"][];
        };
        /** InterestResponse */
        InterestResponse: {
            /** Id */
            id: number;
            /** Name */
            name: string;
            /** Tree Number */
            tree_number: string;
        };
        /** InterestTreeResponse */
        InterestTreeResponse: {
            /** Id */
            id: number;
            /** Name */
            name: string;
            /** Tree Number */
            tree_number: string;
            /** Parent Id */
            parent_id?: number | null;
            /**
             * Children
             * @default []
             */
            children: components["schemas"]["InterestTreeResponse"][];
            /** Children Count */
            children_count: number;
        };
        /** Message */
        Message: {
            /** Message */
            message: string;
        };
        /** NewPassword */
        NewPassword: {
            /** Token */
            token: string;
            /** New Password */
            new_password: string;
        };
        /**
         * NewsletterCadence
         * @description Newsletter cadences
         * @enum {integer}
         */
        NewsletterCadence: NewsletterCadence;
        /** PasswordCheckRequest */
        PasswordCheckRequest: {
            /** Password */
            password: string;
            /** User Inputs */
            user_inputs?: string[] | null;
            /** Max Length */
            max_length?: number | null;
        };
        /**
         * @description **Password strength scores**
         *
         *     - 0: TOO_GUESSABLE
         *     - 1: VERY_GUESSABLE
         *     - 2: SOMEWHAT_GUESSABLE
         *     - 3: SAFELY_UNGUESSABLE
         *     - 4: VERY_UNGUESSABLE
         * @example 0
         * @enum {integer}
         */
        PasswordStrengthScore: PasswordStrengthScore;
        /** PublicationArticleListResponse */
        PublicationArticleListResponse: {
            /** Articles */
            articles: components["schemas"]["ArticleSummary"][];
            /** Total */
            total: number;
            /** Page */
            page: number;
            /** Page Size */
            page_size: number;
            /** Total Pages */
            total_pages: number;
            /** Publication Id */
            publication_id: string;
            /** Publication Name */
            publication_name?: string | null;
        };
        /** PublicationListResponse */
        PublicationListResponse: {
            /** Publications */
            publications: components["schemas"]["PublicationSummary"][];
            /** Total */
            total: number;
            /** Page */
            page: number;
            /** Page Size */
            page_size: number;
            /** Total Pages */
            total_pages: number;
        };
        /** PublicationSummary */
        PublicationSummary: {
            /** Id */
            id: string;
            /** Name */
            name?: string | null;
            /** Domain */
            domain?: string | null;
            /**
             * Article Count
             * @default 0
             */
            article_count: number;
        };
        /** RefreshTokenRequest */
        RefreshTokenRequest: {
            /** Refresh Token */
            refresh_token: string;
        };
        /** SpecialtyResponse */
        SpecialtyResponse: {
            /** Id */
            id: number;
            /** Name */
            name: string;
        };
        /** SpecialtyTreeResponse */
        SpecialtyTreeResponse: {
            /** Id */
            id: number;
            /** Name */
            name: string;
            /** Country Code */
            country_code: string;
            /** Parent Id */
            parent_id?: number | null;
            /**
             * Children
             * @default []
             */
            children: components["schemas"]["SpecialtyTreeResponse"][];
            /** Children Count */
            children_count: number;
        };
        /**
         * @description **Theme types**
         *
         *     - 0: LIGHT
         *     - 1: DARK
         *     - 2: SYSTEM
         * @example 2
         * @enum {integer}
         */
        Theme: Theme;
        /** Token */
        Token: {
            /** Access Token */
            access_token: string;
            /** Refresh Token */
            refresh_token: string;
            /**
             * Token Type
             * @default bearer
             */
            token_type: string;
        };
        /** UserInterestRequest */
        UserInterestRequest: {
            /** Interest Ids */
            interest_ids: number[];
        };
        /**
         * UserProfileCreate
         * @description Explicit schema for profile creation with required fields
         */
        UserProfileCreate: {
            /** Full Name */
            full_name: string;
            /** Country Code */
            country_code: string;
            /** Health Care Provider */
            health_care_provider: boolean;
            /** Npi Number */
            npi_number?: number | null;
            /** Doctor Specialty */
            doctor_specialty?: string | null;
            /** Profession */
            profession?: string | null;
            /** Region Code */
            region_code?: string | null;
            theme?: components["schemas"]["Theme"] | null;
            /** Cookies */
            cookies?: boolean | null;
            /** Newsletter */
            newsletter?: boolean | null;
            cadence?: components["schemas"]["NewsletterCadence"] | null;
            /** Opt Out Sale */
            opt_out_sale?: boolean | null;
            /** Opt Out Targeting */
            opt_out_targeting?: boolean | null;
            /** Opt Out Interests */
            opt_out_interests?: boolean | null;
        };
        /** UserProfileResponse */
        UserProfileResponse: {
            /** Id */
            id: number;
            /** User Id */
            user_id: number;
            /** Full Name */
            full_name: string | null;
            /** Country Code */
            country_code: string | null;
            /** Region Code */
            region_code: string | null;
            /** Health Care Provider */
            health_care_provider?: boolean | null;
            /** Npi Number */
            npi_number: number | null;
            /** Doctor Specialty */
            doctor_specialty?: string | null;
            /** Profession */
            profession?: string | null;
            theme: components["schemas"]["Theme"] | null;
            /** Cookies */
            cookies: boolean | null;
            /** Newsletter */
            newsletter: boolean | null;
            cadence?: components["schemas"]["NewsletterCadence"] | null;
            /** Opt Out Sale */
            opt_out_sale?: boolean | null;
            /** Opt Out Targeting */
            opt_out_targeting?: boolean | null;
            /** Opt Out Interests */
            opt_out_interests?: boolean | null;
        };
        /**
         * UserProfileUpdate
         * @description Explicit schema for profile updates - all fields optional
         */
        UserProfileUpdate: {
            /** Full Name */
            full_name?: string | null;
            /** Country Code */
            country_code?: string | null;
            /** Region Code */
            region_code?: string | null;
            /** Health Care Provider */
            health_care_provider?: boolean | null;
            /** Npi Number */
            npi_number?: number | null;
            /** Doctor Specialty */
            doctor_specialty?: string | null;
            /** Profession */
            profession?: string | null;
            theme?: components["schemas"]["Theme"] | null;
            /** Cookies */
            cookies?: boolean | null;
            /** Newsletter */
            newsletter?: boolean | null;
            cadence?: components["schemas"]["NewsletterCadence"] | null;
            /** Opt Out Sale */
            opt_out_sale?: boolean | null;
            /** Opt Out Targeting */
            opt_out_targeting?: boolean | null;
            /** Opt Out Interests */
            opt_out_interests?: boolean | null;
        };
        /** UserRegistration */
        UserRegistration: {
            /** Full Name */
            full_name: string;
            /** Country Code */
            country_code: string;
            /** Health Care Provider */
            health_care_provider: boolean;
            /** Npi Number */
            npi_number?: number | null;
            /** Doctor Specialty */
            doctor_specialty?: string | null;
            /** Profession */
            profession?: string | null;
            /** Region Code */
            region_code?: string | null;
            theme?: components["schemas"]["Theme"] | null;
            /** Cookies */
            cookies?: boolean | null;
            /** Newsletter */
            newsletter?: boolean | null;
            cadence?: components["schemas"]["NewsletterCadence"] | null;
            /** Opt Out Sale */
            opt_out_sale?: boolean | null;
            /** Opt Out Targeting */
            opt_out_targeting?: boolean | null;
            /** Opt Out Interests */
            opt_out_interests?: boolean | null;
            /**
             * Email
             * Format: email
             */
            email: string;
            /** Password */
            password: string;
        };
        /** UserResponse */
        UserResponse: {
            /**
             * Email
             * Format: email
             */
            email: string;
            /**
             * Identifier
             * Format: uuid
             */
            identifier: string;
            /** Is Active */
            is_active: boolean;
            /**
             * Created At
             * Format: date-time
             */
            created_at: string;
            /**
             * Updated At
             * Format: date-time
             */
            updated_at: string;
        };
        /** UserSpecialtyRequest */
        UserSpecialtyRequest: {
            /**
             * Specialty Ids
             * @default []
             */
            specialty_ids: number[];
        };
        /** ValidationError */
        ValidationError: {
            /** Location */
            loc: (string | number)[];
            /** Message */
            msg: string;
            /** Error Type */
            type: string;
        };
        /**
         * @description **Non US Medical specialties enum**
         *
         *     - Accident and emergency medicine: ACCIDENT_EMERGENCY
         *     - Anaesthesiology and intensive care: ANAESTHESIOLOGY
         *     - Cardiology: CARDIOLOGY
         *     - Dermatology: DERMATOLOGY
         *     - Endocrinology: ENDOCRINOLOGY
         *     - Gastroenterology: GASTROENTEROLOGY
         *     - General paediatricians: GENERAL_PAEDIATRICIANS
         *     - General practitioners: GENERAL_PRACTITIONERS
         *     - General surgery: GENERAL_SURGERY
         *     - Generalist medical practitioners: GENERALIST_MEDICAL
         *     - Gynaecologists and obstetricians: GYNAECOLOGY_OBSTETRICS
         *     - Haematology: HAEMATOLOGY
         *     - Immunology: IMMUNOLOGY
         *     - Internal medicine: INTERNAL_MEDICINE
         *     - Medical doctors not further defined: MEDICAL_DOCTORS_NOT_DEFINED
         *     - Microbiology-bacteriology: MICROBIOLOGY
         *     - Neurological surgery: NEUROLOGICAL_SURGERY
         *     - Neurology: NEUROLOGY
         *     - Occupational medicine: OCCUPATIONAL_MEDICINE
         *     - Oncology: ONCOLOGY
         *     - Ophthalmology: OPHTHALMOLOGY
         *     - Orthopaedics: ORTHOPAEDICS
         *     - Other generalist medical practitioners: OTHER_GENERALIST
         *     - Other specialists not elsewhere classified: OTHER_SPECIALISTS
         *     - Otorhinolaryngology: OTORHINOLARYNGOLOGY
         *     - Pathology: PATHOLOGY
         *     - Plastic surgery: PLASTIC_SURGERY
         *     - Psychiatrists: PSYCHIATRISTS
         *     - Radiology: RADIOLOGY
         *     - Respiratory medicine: RESPIRATORY_MEDICINE
         *     - Thoracic surgery: THORACIC_SURGERY
         *     - Urology: UROLOGY
         *     - Vascular surgery: VASCULAR_SURGERY
         * @example Gastroenterology
         * @enum {string}
         */
        NonUSDoctorSpecialtyEnum: NonUSDoctorSpecialtyEnum;
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "auth-login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/x-www-form-urlencoded": components["schemas"]["Body_auth-login"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Token"];
                };
            };
            /** @description Inactive user */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Incorrect email or password */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "auth-refresh_token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RefreshTokenRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Token"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "auth-logout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Message"];
                };
            };
        };
    };
    "auth-google_login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GoogleLoginResponse"];
                };
            };
        };
    };
    "auth-google_callback": {
        parameters: {
            query: {
                code: string;
                state: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GoogleCallbackResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-get_current_user": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserResponse"];
                };
            };
        };
    };
    "users-delete_current_user": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Message"];
                };
            };
        };
    };
    "users-get_interests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InterestResponse"][];
                };
            };
        };
    };
    "users-update_interests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserInterestRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InterestResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-get_specialties": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SpecialtyResponse"][];
                };
            };
        };
    };
    "users-update_specialties": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserSpecialtyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SpecialtyResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-data_request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DataRequestDetail"];
                };
            };
        };
    };
    "users-create_user_data_request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DataRequestDetail"];
                };
            };
        };
    };
    "users-change_password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ChangePasswordRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Token"];
                };
            };
            /** @description Old password is incorrect */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-register": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserRegistration"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Message"];
                };
            };
            /** @description The user with this email already exists in the system. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-confirm_email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EmailConfirmation"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Message"];
                };
            };
            /** @description Invalid or expired token. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description The user with this email does not exist in the system. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-resend_confirmation_email": {
        parameters: {
            query: {
                email: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Message"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-recover_password": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                email: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Message"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-reset_password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewPassword"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Message"];
                };
            };
            /** @description Invalid or expired token, or inactive user. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description The user with this email does not exist in the system. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "users-check_password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasswordCheckRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PasswordStrengthScore"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "specialties-get_specialties": {
        parameters: {
            query: {
                country_code: string;
                parent_id?: number | null;
                depth?: number | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SpecialtyTreeResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "specialties-get_specialty_from_api": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                npi_number: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "interests-get_interests": {
        parameters: {
            query?: {
                parent_id?: number | null;
                depth?: number | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InterestTreeResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "profile-get_profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserProfileResponse"];
                };
            };
        };
    };
    "profile-update_profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserProfileUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserProfileResponse"];
                };
            };
            /** @description Profile not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "profile-create_profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserProfileCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserProfileResponse"];
                };
            };
            /** @description Profile already exists in the system. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ErrorResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-view_article": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                article_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ArticleDetail"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-feed_articles": {
        parameters: {
            query?: {
                /** @description Interest to filter by */
                interest?: string | null;
                /** @description Boost articles matching multiple tags */
                boost_multiple_matches?: boolean;
                page?: number;
                page_size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ArticleListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-get_saved_articles": {
        parameters: {
            query?: {
                page?: number;
                page_size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ArticleListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-save_article": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                article_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-remove_saved_article": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                article_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-exclude_article": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                article_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-remove_excluded_article": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                article_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-get_seen_articles": {
        parameters: {
            query?: {
                page?: number;
                page_size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ArticleListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-seen_article": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                article_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-search_articles": {
        parameters: {
            query: {
                /** @description Search query for title, author, or DOI */
                q: string;
                page?: number;
                page_size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ArticleListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "articles-similar_articles": {
        parameters: {
            query?: {
                page?: number;
                page_size?: number;
            };
            header?: never;
            path: {
                article_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ArticleListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "publications-publication_articles": {
        parameters: {
            query?: {
                page?: number;
                page_size?: number;
            };
            header?: never;
            path: {
                publication_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PublicationArticleListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    "publications-search_publications": {
        parameters: {
            query: {
                /** @description Search query for publication name */
                q: string;
                page?: number;
                page_size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PublicationListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
}
export enum DataRequestStatus {
    NEW = 0,
    DONE = 5,
    ERROR = 9
}
export enum NewsletterCadence {
    Value1 = 1,
    Value2 = 2,
    Value3 = 3
}
export enum PasswordStrengthScore {
    TOO_GUESSABLE = 0,
    VERY_GUESSABLE = 1,
    SOMEWHAT_GUESSABLE = 2,
    SAFELY_UNGUESSABLE = 3,
    VERY_UNGUESSABLE = 4
}
export enum Theme {
    LIGHT = 0,
    DARK = 1,
    SYSTEM = 2
}
export enum NonUSDoctorSpecialtyEnum {
    ACCIDENT_EMERGENCY = "Accident and emergency medicine",
    ANAESTHESIOLOGY = "Anaesthesiology and intensive care",
    CARDIOLOGY = "Cardiology",
    DERMATOLOGY = "Dermatology",
    ENDOCRINOLOGY = "Endocrinology",
    GASTROENTEROLOGY = "Gastroenterology",
    GENERAL_PAEDIATRICIANS = "General paediatricians",
    GENERAL_PRACTITIONERS = "General practitioners",
    GENERAL_SURGERY = "General surgery",
    GENERALIST_MEDICAL = "Generalist medical practitioners",
    GYNAECOLOGY_OBSTETRICS = "Gynaecologists and obstetricians",
    HAEMATOLOGY = "Haematology",
    IMMUNOLOGY = "Immunology",
    INTERNAL_MEDICINE = "Internal medicine",
    MEDICAL_DOCTORS_NOT_DEFINED = "Medical doctors not further defined",
    MICROBIOLOGY = "Microbiology-bacteriology",
    NEUROLOGICAL_SURGERY = "Neurological surgery",
    NEUROLOGY = "Neurology",
    OCCUPATIONAL_MEDICINE = "Occupational medicine",
    ONCOLOGY = "Oncology",
    OPHTHALMOLOGY = "Ophthalmology",
    ORTHOPAEDICS = "Orthopaedics",
    OTHER_GENERALIST = "Other generalist medical practitioners",
    OTHER_SPECIALISTS = "Other specialists not elsewhere classified",
    OTORHINOLARYNGOLOGY = "Otorhinolaryngology",
    PATHOLOGY = "Pathology",
    PLASTIC_SURGERY = "Plastic surgery",
    PSYCHIATRISTS = "Psychiatrists",
    RADIOLOGY = "Radiology",
    RESPIRATORY_MEDICINE = "Respiratory medicine",
    THORACIC_SURGERY = "Thoracic surgery",
    UROLOGY = "Urology",
    VASCULAR_SURGERY = "Vascular surgery"
}
